/**
 * Is a charger live right now: the one rule every "Online" count and badge
 * reads (Warren's ruling 4, 2026-09-28: fix the sticky online flag).
 *
 * WHY THE FLAG ALONE IS NOT ENOUGH. ocpp sets Charger.is_online true on
 * connect, BootNotification and every Heartbeat, and false only when the
 * socket closes or the reaper runs. When neither fires (the ocpp task
 * restarts with the socket open, so no close event is ever handled) the
 * flag stays true forever, and a page reading it shows a dead charger as
 * Online. Pairing it with a recent heartbeat makes a stuck-true flag decay
 * to Offline within HEARTBEAT_CUTOFF_MS.
 *
 * The Dashboard's Chargers Online KPI (apps/api dashboardAggregations
 * computeNetworkCounts) is the Mongo form of this rule:
 *   is_online: true AND last_heartbeat >= now - HEARTBEAT_CUTOFF_MS
 * isChargerLive is the same rule for a row already in hand (the admin's
 * My Sites badge), so the two can never disagree about one charger.
 *
 * Pure, no ODM: last_heartbeat arrives as a Date server-side and as an ISO
 * string over the wire, and both are accepted.
 */
/** Minutes of silence from a charger before it counts as offline, in ms.
 *  Must stay aligned with the OCPP heartbeat cadence: too high hides
 *  genuine outages, too low flaps during legitimate network jitter. */
export const HEARTBEAT_CUTOFF_MS = 15 * 60 * 1000;
/** True only when the flag is set AND the last heartbeat is no older than
 *  HEARTBEAT_CUTOFF_MS (the boundary itself counts, matching the
 *  aggregation's $gte). A missing or unparseable heartbeat is not live. */
export function isChargerLive(charger, now = Date.now()) {
    if (charger.is_online !== true)
        return false;
    const hb = charger.last_heartbeat;
    if (hb === null || hb === undefined || hb === '')
        return false;
    const hbMs = hb instanceof Date ? hb.getTime() : new Date(hb).getTime();
    if (!Number.isFinite(hbMs))
        return false;
    const nowMs = now instanceof Date ? now.getTime() : now;
    return hbMs >= nowMs - HEARTBEAT_CUTOFF_MS;
}
//# sourceMappingURL=chargerLiveness.js.map